var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 51.7578C25.6262 51.7578 20 57.384 20 64.1797V67.6953L23.6328 71.2109V76.4844H44.7266V64.1797C44.7266 57.384 39.2176 51.7578 32.4219 51.7578Z",
    fill: "#4C5A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5781 51.7578C74.3738 51.7578 80 57.384 80 64.1797V67.6953L76.3672 71.2109V76.4844H55.2734V64.1797C55.2734 57.384 60.7824 51.7578 67.5781 51.7578Z",
    fill: "#4C5A81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58.7891C43.2043 58.7891 37.6953 64.4152 37.6953 71.2109V76.4844H41.2109L44.7266 80H50H55.2734L58.7891 76.4844H62.3047V71.2109C62.3047 64.4152 56.7957 58.7891 50 58.7891Z",
    fill: "#838EAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7891 76.4844H62.3047V71.2109C62.3047 64.4152 56.7957 58.7891 50 58.7891V80H55.2734L58.7891 76.4844Z",
    fill: "#838EAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3672 51.7578H58.7891V42.9688C58.7891 38.1227 62.7321 34.1797 67.5781 34.1797C72.4242 34.1797 76.3672 38.1227 76.3672 42.9688V51.7578Z",
    fill: "#E4E6EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4219 51.7578C27.5758 51.7578 23.6328 47.8148 23.6328 42.9688C23.6328 38.1227 27.5758 34.1797 32.4219 34.1797C37.2679 34.1797 41.2109 38.1227 41.2109 42.9688C41.2109 47.8148 37.2679 51.7578 32.4219 51.7578Z",
    fill: "#E4E6EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8516 67.6953V72.9688H60.5469C57.639 72.9688 55.2734 75.3343 55.2734 78.2422V80H74.6094C77.5218 80 80 77.639 80 74.7266V67.6953H72.8516Z",
    fill: "#E4E6EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7266 78.2422C44.7266 75.3343 42.361 72.9688 39.4531 72.9688H27.1484V67.6953H20V74.7266C20 77.639 22.4782 80 25.3906 80H44.7266V78.2422Z",
    fill: "#E4E6EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58.7891C53.8833 58.7891 57.0312 55.6411 57.0312 51.7578C57.0312 47.8746 53.8833 44.7266 50 44.7266C46.1167 44.7266 42.9688 47.8746 42.9688 51.7578C42.9688 55.6411 46.1167 58.7891 50 58.7891Z",
    fill: "#E4E6EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0312 51.7578C57.0312 47.88 53.8779 44.7266 50 44.7266V58.7891C53.8779 58.7891 57.0312 55.6357 57.0312 51.7578Z",
    fill: "#E4E6EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3602 20C52.429 20 50.9974 20.8823 50 21.993C49.0026 20.8823 47.5709 20 45.6398 20C42.2083 20 39.52 22.8513 39.52 26.4922C39.52 30.3133 42.4898 32.9368 46.6011 36.4044C47.3067 37.0018 48.0585 37.6352 48.8481 38.3202L50 39.3175L51.1518 38.3202C51.9398 37.637 52.6917 37.0018 53.3971 36.4061C56.8544 33.4903 60.4798 30.5934 60.4798 26.4922C60.4799 22.8513 57.7917 20 54.3602 20Z",
    fill: "#AF8EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3972 36.4061C56.8544 33.4903 60.4798 30.5934 60.4798 26.4922C60.4798 22.8513 57.7917 20 54.3601 20C52.4291 20 50.9974 20.8823 50 21.993V39.3175L51.1518 38.3202C51.9398 37.637 52.6917 37.0018 53.3972 36.4061Z",
    fill: "#AF8EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.e419f231d5db58d8271189be966f3b88.svg";
export { ForwardRef as ReactComponent };